import * as React from "react";
import Button from "@material-ui/core/Button";
import ApplicationStatusMessageConfirmationModal from "./ApplicationStatusMessageConfirmationModal";

type State = {
  showModal: boolean;
};

type Props = {
  statusMessage: any;
};

export default class ApplicationStatusMessageActivateContainer extends React.Component<
  Props,
  State
> {
  state = {
    showModal: false,
  };

  onCloseModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    return (
      <>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            this.setState({ showModal: true });
          }}
        >
          Activate
        </Button>
        {this.state.showModal && (
          <ApplicationStatusMessageConfirmationModal
            statusMessage={this.props.statusMessage}
            onClose={this.onCloseModal}
          />
        )}
      </>
    );
  }
}
